module.exports = __webpack_public_path__ + "static/media/Solid_Selected.8ec11b7e.svg";